export default __webpack_public_path__ + "static/media/TT.d12a57df.ico";